import React, { Component } from "react";
//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert";
//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Th, Thead, Tr } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { Button, Card, CardBody, CardTitle, Col, Row } from "reactstrap";
//Import actions redux
import {
  deleteUser, disableUser,
  enableUser,
  userChangePassword
} from "../../store/actions";


class UsersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      usrlist: this.props.usrlist,
      actionUsr: false,
      pswd: false,
      usrToAction: null,
      action: null,
      new_pwd: null,
    };
  }

  action() {
    if (this.state.action === "disable") {
      this.props.disableUser(
        this.state.user.name,
        this.state.usrToAction,
        this.state.user.token,
        this.props.history
      );
    } else if (this.state.action === "enable") {
      this.props.enableUser(
        this.state.user.name,
        this.state.usrToAction,
        this.state.user.token,
        this.props.history
      );
    } else if (this.state.action === "delete") {
      this.setState({
        actionUsr: false,
        success_dlg: true,
        dynamic_title: "Usuario eliminado",
      });
      this.props.deleteUser(this.state.user.name, this.state.usrToAction, this.state.user.token)
    }
  }

  changePwd() {
    this.setState({
      pswd: false,
      success_dlg: true,
      dynamic_title: "Contraseña actualizada",
    });
    this.props.userChangePassword(
      this.state.user.name,
      this.state.usrToAction,
      this.state.new_pwd,
      this.state.user.token,
      this.props.history
    );
  }

  success(){
    this.props.history.go()
    this.setState({ success_dlg: false })
  }

  render() {
    return (
      <React.Fragment>
        <Row>
          <Col>
            <Card>
              <CardBody>
              <CardTitle className="mb-4">{this.props.t('Usuarios')}</CardTitle>
                
                <div className="table-responsive">
                  <table className="table table-nowrap table-centered mb-0">
                   <Thead>
                            <Tr>
                              <Th><i className="bx bx-user-pin mr-2 my-auto"></i>{this.props.t('Nombre de usuario')}</Th>
                              <Th><i className="bx bx-check-circle mr-2 my-auto"></i>{this.props.t('Estado')}</Th>
                              <Th><i className="bx bx-brush mr-2 my-auto"></i>{this.props.t('Acciones')}</Th>
                            </Tr>
                    </Thead>
                    <tbody>
                      {this.state.usrlist.map((user, key) => {
                        return (
                          <tr key={key}>
                            <td>
                            <i className="bx bx-user"></i><span className="txtName">{user.name}</span>
                            </td>
                            <td>
                              <span className="txtName">
                                {user.status === "enabled"
                                  ? <div><i className="bx bx-run"></i> {this.props.t('Habilitado')}</div>
                                  : <div><i className="bx bx-stop"></i> {this.props.t('Deshabilitado')}</div>}
                              </span>
                            </td>
                            <td>
                              {this.state.user.role_id === 1 && (
                                
                                <Button
                                  color={
                                    user.status === "enabled"
                                      ? "danger"
                                      : "primary"
                                  }
                                  className="btn btn-primary waves-effect waves-light buttonStatus usersButtons my-auto"
                                  onClick={() =>
                                    this.setState({
                                      actionUsr: true,
                                      usrToAction: user.name,
                                      action:
                                        user.status === "enabled"
                                          ? "disable"
                                          : "enable",
                                    })
                                  }
                                > <i className="bx bx-user-minus"></i>
                                  {user.status === "enabled"
                                    ? "Dar de baja"
                                    : "Dar de alta"}
                                </Button>
                              )}
                              {this.state.user.role_id === 1 && (
                                (this.state.user.role_id === 1 && this.state.user.name!==user.name) &&(
                                <Button
                                  color="danger"
                                  className="btn btn-danger waves-effect waves-light buttonStatus usersButtons my-auto"
                                  onClick={() =>
                                    this.setState({
                                      actionUsr: true,
                                      usrToAction: user.name,
                                      action: "delete"
                                    })
                                  }
                                >
                                  <i className="bx bx-user-x"></i> {this.props.t('Eliminar usuario')}
                                </Button>)
                              )}
                              {(this.state.user.role_id === 1 ||
                                this.state.user.id === user.id) && (
                                <Button
                                  color={"primary"}
                                  className="btn btn-primary waves-effect waves-light buttonStatus usersButtons my-auto"
                                  onClick={() =>
                                    this.setState({
                                      pswd: true,
                                      usrToAction: user.name,
                                    })
                                  }
                                >
                                  <i className="bx bx-key"></i>{this.props.t('Cambiar contraseña')}
                                </Button>
                              )}
                              {(this.state.user.role_id === 1 ||
                                this.state.user.id === user.id) && (
                                <Button
                                  color={"primary"}
                                  className="btn btn-primary waves-effect waves-light buttonStatus usersButtons my-auto"
                                  onClick={() =>
                                    this.props.history.push({
                                      pathname: "/updateuser",
                                      state: user,
                                    })
                                  }
                                >
                                  <i className="bx bx-edit-alt"></i> {this.props.t('Editar usuario')}
                                </Button>
                              )}
                              {this.state.actionUsr ? (
                                <SweetAlert
                                  showCancel
                                  title="¿Estás seguro?"
                                  cancelBtnBsStyle="danger"
                                  confirmBtnBsStyle="success"
                                  confirmBtnText={this.props.t("ok")}
                                  cancelBtnText={this.props.t("Cancel")}
                                  onConfirm={() => this.action()}
                                  onCancel={() =>
                                    this.setState({ actionUsr: false })
                                  }
                                ></SweetAlert>
                              ) : null}

                              {this.state.pswd ? (
                                <SweetAlert
                                  showCancel
                                  title="Nueva contraseña"
                                  cancelBtnBsStyle="danger"
                                  confirmBtnBsStyle="success"
                                  confirmBtnText={this.props.t("ok")}
                                  cancelBtnText={this.props.t("Cancel")}
                                  onConfirm={() => this.changePwd()}
                                  onCancel={() =>
                                    this.setState({ pswd: false })
                                  }
                                >
                                  <input
                                    type="password"
                                    className="form-control"
                                    placeholder="Nueva contraseña"
                                    onChange={(event) =>
                                      this.setState({
                                        new_pwd: event.target.value,
                                      })
                                    }
                                  />
                                </SweetAlert>
                              ) : null}

                              {this.state.success_dlg ? (
                                <SweetAlert
                                  success
                                  title={this.state.dynamic_title}
                                  confirmBtnText={this.props.t("ok")}
              
                                  onConfirm={() => this.success()}
                                ></SweetAlert>
                              ) : null}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

const mapStateprops = (state) => {
  const {
    disableError,
    disableMessage,
    loadingDisableUser,
    enableError,
    enableMessage,
    loadingEnableUser,
  } = state.StatusUser;
  const { changeSuccessMsg, changeError } = state.ChangePassword;
  const {
    deleteUserError,
    deleteUsermessage,
    loadingDeleteUser,
  } = state.DeleteUser;
  return {
    disableError,
    disableMessage,
    loadingDisableUser,
    enableError,
    enableMessage,
    loadingEnableUser,
    changeSuccessMsg,
    changeError,
    deleteUserError,
    deleteUsermessage,
    loadingDeleteUser,
  };
};
export default withRouter(
  connect(mapStateprops, {
    disableUser,
    enableUser,
    userChangePassword,
    deleteUser,
  })(withNamespaces()(UsersList))
);
